import { useSnackbar as useSnackbar$1, DURATION, PLACEMENT } from 'baseui/snackbar';
import { useRef, useCallback } from 'react';
import { mergeOverrides } from '../../overrides.js';
import 'react/jsx-runtime';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useStyletron, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { ActionButton } from './action-button.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getVariantStyles = (theme, variant) => {
  switch (variant) {
    case "error":
      return {
        backgroundColor: theme.colors["background-brand-error"],
        color: theme.colors["text-global-inverse"]
      };
    case "success":
      return {
        backgroundColor: theme.colors["background-brand-secondary"],
        color: theme.colors["background-brand-inverse"]
      };
    case "default":
    default:
      return {
        backgroundColor: theme.colors["background-global-inverse"],
        color: theme.colors["text-global-inverse"]
      };
  }
};
const getSizeStyles = (theme, size) => {
  switch (size) {
    case "small":
      return theme.typography.p4;
    case "large":
    default:
      return theme.typography.p3;
  }
};
const getPlacementStyles = (theme, placement) => {
  const bottomSpace = { bottom: theme.space[56] };
  if (placement === PLACEMENT.bottom) {
    return __spreadProps(__spreadValues({}, bottomSpace), { left: "50%", transform: "translate(-50%, -50%)" });
  }
  return __spreadProps(__spreadValues({}, bottomSpace), { left: theme.space[48] });
};
const getStyles = (theme, element, variant = "default", placement = "bottom", size = "large") => {
  switch (element) {
    case "Root":
      return __spreadValues(__spreadValues(__spreadValues({
        minWidth: void 0,
        position: "fixed",
        overflow: "hidden",
        zIndex: theme.zIndices.fixed,
        borderTopLeftRadius: theme.radii[4],
        borderTopRightRadius: theme.radii[4],
        borderBottomRightRadius: theme.radii[4],
        borderBottomLeftRadius: theme.radii[4],
        boxShadow: theme.shadow[8]
      }, getVariantStyles(theme, variant)), getPlacementStyles(theme, placement)), getSizeStyles(theme, size));
    case "Content":
      return { backgroundColor: "inherit", color: "inherit" };
    case "Message":
      return { fontWeight: "inherit", fontSize: "inherit", lineHeight: "inherit" };
    default:
      return {};
  }
};
const useSnackbar = () => {
  const { enqueue: baseEnqueue, dequeue: baseDequeue } = useSnackbar$1();
  const [, theme] = useStyletron();
  const enqueueWithRef = useRef(baseEnqueue);
  const dequeue = useRef(baseDequeue);
  const enqueue = useCallback((_a) => {
    var _b = _a, { variant = "default", size = "large", placement = "bottom", overrides, duration = DURATION.short, $style } = _b, props = __objRest(_b, ["variant", "size", "placement", "overrides", "duration", "$style"]);
    return enqueueWithRef.current(__spreadValues({
      overrides: mergeOverrides({
        Root: {
          style: () => mergeStyles(getStyles(theme, "Root", variant, placement, size), typeof $style === "function" ? $style({ $theme: theme }) : $style)
        },
        Content: {
          style: () => getStyles(theme, "Content")
        },
        Message: {
          style: () => getStyles(theme, "Message")
        },
        ActionButtonContainer: {
          component: ActionButton
        }
      }, overrides)
    }, props), duration);
  }, [theme]);
  return { enqueue, dequeue: dequeue.current };
};

export { useSnackbar };
